export const LOGISTICS_OASR_DASHBOARD: string = 'dashboard';
export const LOGISTICS_OASR_VEHICLE: string = 'vehicle';
export const LOGISTICS_OASR_VEHICLE_ENTRY: string = 'vehicle-check-in';
export const LOGISTICS_OASR_VEHICLE_EXIT: string = 'vehicle-check-out';
export const LOGISTICS_OASR_VEHICLE_STOCK: string = 'vehicle-stock';
export const LOGISTICS_OASR_VEHICLE_DELIVERED: string = 'vehicle-delivered';
export const LOGISTICS_OASR_VEHICLE_DETAIL: string = 'detail';
export const LOGISTICS_OASR_CHECK_IN: string = 'check-in';
